import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../../utils/apiConfig';
import ProductEditAccordion, { getEnabledSectionKeys } from './ProductEditAccordion';
import { mapProductFromApiAsync } from './utils/mapProduct';

function EditProduct({
  ProductData,
  sendDataToParent,
  onFeatureOrderChange,
  featureOrderSaveToken = 0,
  onDetailTabsChange,
  detailTabsSaveToken = 0,
  tabTypes = [],
}) {
  const [formData, setFormData] = useState(ProductData || {});
  const [slugManual, setSlugManual] = useState(true);
  const [expandAll, setExpandAll] = useState(false);
  const [activeKey, setActiveKey] = useState('details');

  const productId = formData?.ProductId;
  const childTabsEnabled = !!productId;

  const refreshProduct = async () => {
    if (!productId) return;
    try {
      const response = await axios.get(`${getApiBaseUrl()}/ec-product/getById`, {
        params: { ProductId: productId },
      });
      if (response.data?.data) {
        const mapped = await mapProductFromApiAsync(response.data.data);
        setFormData(mapped);
        if (sendDataToParent) sendDataToParent(mapped);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setFormData(ProductData || {});
  }, [ProductData]);

  const handleData = (data) => {
    setFormData(data);
    if (sendDataToParent) sendDataToParent(data);
  };

  const handleDetailTabsChange = useCallback((change) => {
    if (onDetailTabsChange) onDetailTabsChange(change);
    if (change?.tabs) {
      setFormData((prev) => ({ ...prev, DetailTabs: change.tabs }));
    }
  }, [onDetailTabsChange]);

  const handleExpandAllChange = (checked) => {
    setExpandAll(checked);
    if (checked) {
      setActiveKey(getEnabledSectionKeys(childTabsEnabled));
    } else {
      setActiveKey('details');
    }
  };

  const handleAccordionSelect = (key) => {
    const enabledKeys = getEnabledSectionKeys(childTabsEnabled);
    if (Array.isArray(key) && key.some((sectionKey) => !enabledKeys.includes(sectionKey))) return;
    if (typeof key === 'string' && key && !enabledKeys.includes(key)) return;

    if (expandAll) {
      let nextKey = 'details';
      if (Array.isArray(key)) {
        const collapsed = enabledKeys.find((sectionKey) => !key.includes(sectionKey));
        nextKey = collapsed || key[0] || 'details';
      } else if (key) {
        nextKey = key;
      }
      if (!enabledKeys.includes(nextKey)) return;
      setExpandAll(false);
      setActiveKey(nextKey);
      return;
    }

    setActiveKey(key);
  };

  return (
    <div className="card-body px-0">
      <ProductEditAccordion
        activeKey={activeKey}
        onSelect={handleAccordionSelect}
        expandAll={expandAll}
        onExpandAllChange={handleExpandAllChange}
        childTabsEnabled={childTabsEnabled}
        formData={formData}
        productId={productId}
        slugManual={slugManual}
        onSlugManualChange={setSlugManual}
        onDataChange={handleData}
        onRefresh={refreshProduct}
        onFeatureOrderChange={onFeatureOrderChange}
        featureOrderSaveToken={featureOrderSaveToken}
        onDetailTabsChange={handleDetailTabsChange}
        detailTabsSaveToken={detailTabsSaveToken}
        tabTypes={tabTypes}
      />
    </div>
  );
}

export default EditProduct;
